"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaApi = void 0;
var tslib_1 = require("tslib");
var private_media_1 = require("../private-media");
var WixStatics_1 = require("../wixStatics/WixStatics");
var ImageSDK_1 = require("../../model/ImageSDK/ImageSDK");
var MediaApi = /** @class */ (function () {
    function MediaApi(api) {
        this.api = api;
        this.mediaService = new private_media_1.PrivateMediaService();
    }
    MediaApi.prototype.uploadFile = function (file) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.getMediaToken()];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, this.mediaService.uploadFile(file, data.token)];
                }
            });
        });
    };
    /**
     * @deprecated
     * @param {string} fileUrl
     * @return {string}
     */
    MediaApi.wixStaticFileUrl = function (fileUrl) {
        return WixStatics_1.WixStatics.fileUrl(fileUrl);
    };
    /**
     * @deprecated
     * use WixStatics
     * @param {string} fileUrl
     * @return {string}
     */
    MediaApi.wixStaticVideoUrl = function (fileUrl) {
        return WixStatics_1.WixStatics.videoUrl(fileUrl);
    };
    /**
     * @deprecated
     * use WixStatics
     * @param {string} fileUrl
     * @return {string}
     */
    MediaApi.wixStaticImageUrl = function (fileUrl) {
        return WixStatics_1.WixStatics.imageUrl(fileUrl);
    };
    /**
     * @deprecated
     * use WixStatics
     * @param {string} wixMPImageURL
     * @return {{path: string; fileName: string}}
     */
    MediaApi.getWixmpFileNameFromImageURL = function (wixMPImageURL) {
        return WixStatics_1.WixStatics.getWixmpFileNameFromImageURL(wixMPImageURL);
    };
    /**
     * @deprecated
     * use WixStatics
     * @param {string} image
     * @return {boolean}
     */
    MediaApi.isWixmpImageURL = function (image) {
        return WixStatics_1.WixStatics.isWixmpImageURL(image);
    };
    MediaApi.getImageUrl = function (fileUploadResponse, targetWidth, targetHeight) {
        var file_url = fileUploadResponse.file_url, height = fileUploadResponse.height, width = fileUploadResponse.width;
        var imageSDK = new ImageSDK_1.ImageSDK({
            relativeUrl: file_url,
            sourceWidth: width,
            sourceHeight: height,
            targetWidth: targetWidth || width,
            targetHeight: targetHeight || height,
            url: '',
        });
        return imageSDK.getScaledUrl();
    };
    MediaApi.WIXMP_IMAGE_BASE_URL = WixStatics_1.WixStatics.WIXMP_IMAGE_BASE_URL;
    MediaApi.WIX_STATIC = WixStatics_1.WixStatics.WIX_STATIC;
    MediaApi.WIX_STATIC_VIDEO_BASE_URL = WixStatics_1.WixStatics.WIX_STATIC_VIDEO_BASE_URL;
    return MediaApi;
}());
exports.MediaApi = MediaApi;
//# sourceMappingURL=MediaApi.js.map